import { Button, Input, Modal, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import { ReactComponent as Checked } from "../../../assets/Icons/checkedBox.svg";
import { ReactComponent as SearchIcon } from "../../../assets/Icons/SearchIcon.svg";
import { ReactComponent as UnChecked } from "../../../assets/Icons/uncheckedBox.svg";
import CustomSelect from "../../../Reuseable/Select/Select";
import "./EditAllocationModal.scss";
import { ChangeCaseToUnallocate, postAllocateCase } from "../../../assets/api/allocation";
import { useDispatch, useSelector } from "react-redux";
import CustomNotification from "../../../Reuseable/CustomNotification/CustomNotification";
import { fetchAgencyUsers } from "../../../store/agencySlice";

const EditAllocationModal = ({ open, onClose, record, type, setRefresh }) => {
  const [allocationType, setAllocationType] = useState("change");
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState();
  const [selectedRole, setSelectedRole] = useState();
  const [value, setValue] = useState("");
  const { token } = useSelector(state => state.auth);
  const { user_list, user_loading } = useSelector((state) => state?.agency);
  const dispatch = useDispatch();
  const [params, setParams] = useState({})


console.log(user_list,'user_listuser_list');
  const getValue = (key) => record?.[key] ?? "-";

  const handleUpdateAllocation = async () => {
    try {
      setLoading(true);
      const res = await ChangeCaseToUnallocate({
        xbucket_data_id: record?.id
      }, token)
      if (res?.status === 200) {
        CustomNotification.show(res?.data?.message, 'success');
        onClose();
        setRefresh((prev) => (!prev));
          setLoading(false);
      }
    } catch (error) {
      console.error(error, 'error message;');
    }
  }

  const handleChangeAllocation = async () => {
    let payload = {
      allocation_type: "manual",
      cases: [record?.id],
      [selectedRole]: [selectedUser],
    };
    try {
      setLoading(true)
      const response = await postAllocateCase(
        { role_type: selectedRole, payload },
        token
      );
      if (response?.status === 200) {
        CustomNotification.show(
          response?.data?.message || "Cases allocated successfully",
          "success"
        );
        onClose();
        setLoading(false);

      }
      else {
        CustomNotification.show(response?.response?.data?.errors, 'error')
        setLoading(false);
      }
    } catch (error) {
      console.error(error, 'errorerror');
    }
  }





  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      setParams((prev) => ({
        ...prev,
        search: value
      }));
    }
  };


  useEffect(() => {
    if(!open) {
      return;
    }
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([_, v]) => v !== undefined && v !== "" && v !== "all")
    );
    
  if(params?.role  !== undefined)  {
      dispatch(fetchAgencyUsers(cleanParams));
  }
  }, [dispatch, params, open]);

  const roleOptions = [
    { label: "All", value: "" },
    { label: "Supervisor", value: "supervisors" },
    { label: "Field Agent", value: "field_agents" },
    { label: "Teamlead", value: "teamleads" },
    { label: "Telecaller", value: "telecallers" },
  ];

  const rolesVal = {
    supervisors: "supervisor",
    field_agents: "fieldagent",
    teamleads: "teamlead",
    telecallers: "telecaller",
  };
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title="Edit Allocation"
      width={638}
      className="editAllocationModal"
    >
      <div className="allocationInfo">
        <h3>Customer Information</h3>
        <div className="infoGrid">
          <div className="infoColumn">
            <div className="infoItem">
              <p className="infoLabel">Name</p>
              <p className="infoValue">{getValue("customer_name")}</p>
            </div>
            <div className="infoItem">
              <p className="infoLabel">Loan No</p>
              <p className="infoValue">{getValue("loan_no")}</p>
            </div>
            <div className="infoItem">
              <p className="infoLabel">Bucket</p>
              <p className="infoValue">{getValue("bucket")}</p>
            </div>
          </div>
          <div className="infoColumn">
            <div className="infoItem">
              <p className="infoLabel">Amount Overdue</p>
              <p className="infoValue">{getValue("amount_overdue")}</p>
            </div>
            <div className="infoItem">
              <p className="infoLabel">Bank</p>
              <p className="infoValue">{getValue("bank")}</p>
            </div>
            <div className="infoItem">
              <p className="infoLabel">Product</p>
              <p className="infoValue">{getValue("product")}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="allocationActions">
        <p className="infoLabel">Select Allocation Type</p>
        <div className="radioWrapper">
          <div
            className={`customRadio ${allocationType === "unallocate" ? "active" : ""
              }`}
            onClick={() => setAllocationType("unallocate")}
          >
            <span className="radioIcon">
              {allocationType === "unallocate" ? <Checked /> : <UnChecked />}
            </span>
            Unallocate
          </div>

          <div
            className={`customRadio ${allocationType === "change" ? "active" : ""
              }`}
            onClick={() => setAllocationType("change")}
          >
            <span className="radioIcon">
              {allocationType === "change" ? <Checked /> : <UnChecked />}
            </span>
            Change Allocation
          </div>
        </div>

        {allocationType === "change" && (
          <div className="selectUserWrapper">
            <p>Select User</p>

            <CustomSelect
              placeholder="Select User"
              value={selectedUser}
              onChange={setSelectedUser}
              dropdownRender={(menu) => (
                <div className="customUserDropdown" onMouseDown={(e) => e.stopPropagation()}>
                  <div className="dropdownHeader">
                    <CustomSelect
                      className="roleSelect"

                      value={selectedRole}
                      onChange={(role, option) => {


                        setSelectedRole(role);
                        setParams((prev) => ({
                          ...prev,
                          role: rolesVal?.[role],
                        }));
                      }}
                      options={roleOptions}
                    />
                    <input
                      className="dropdownSearch"
                      placeholder="Search"
                      value={value}
                      onChange={(e) => setValue(e.target.value)}
                      onKeyDown={handleKeyDown}
                    />

                    <span className="searchIcon">
                      <SearchIcon />
                    </span>
                  </div>
                  <div className="dropdownBody">{menu}</div>
                </div>
              )}
              options={
                user_loading
                  ? Array(5)
                    .fill({})
                    .map((item, index) => ({
                      label: <Skeleton.Input size="small" active />,
                      value: index,
                    }))
                  : user_list?.results?.map((u) => ({
                    label: u?.full_name,
                    value: u?.agent_id,
                  }))
              }
            />
          </div>
        )}
      </div>

      <div className="submitBtnWrapper">
        <Button loading={loading} type="primary" className="submitBtn" onClick={allocationType === 'change' ? handleChangeAllocation : handleUpdateAllocation}>
          Submit
        </Button>
      </div>
    </Modal>
  );
};

export default EditAllocationModal;
